// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to info@fahrschule-star.ch.

// ----------------------------------------------------------------------

const de = {
  demo: {
    title: `English`,
    introduction: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.`,
  },
  docs: {
    hi: `Hi`,
    description: `Need help? \n Please check our docs.`,
    documentation: `documentation`,
  },
  welcomeHome: "Fahren und Verkehrsregeln lernen",
  welcomeMinimal:
    "In unserer Fahrschule können Sie Ihren Führerschein in Raten bezahlen. Wenn du Automatik oder Schaltgetriebe fahren lernen willst, musst du nicht viel sparen. Wir geben Ihnen professionelle Fahrstunden und ermöglichen Ihnen, Ihre Fahrstunden in Raten zu bezahlen.",
  drivingLessonsHome: "Fahren und Verkehrsregeln lernen",
  drivingLessonsHomeDesc:
    "In unserer Fahrschule können Sie Ihren Führerschein in Raten bezahlen. Wenn du Automatik oder Schaltgetriebe fahren lernen willst, musst du nicht viel sparen. Wir geben Ihnen professionelle Fahrstunden und ermöglichen Ihnen, Ihre Fahrstunden in Raten zu bezahlen.",
  welcomeTextHero: "Wir lernen leicht zu fahren",
  RegistrationBtn: "Anmeldung",
  MoreBtn: "Mehr",
  reviewStar: "bewertungen",
  title1Course: "Erste Hilfe",
  parraph1Course: `Erste-Hilfe-Kurs für nur 69 CHF.
  Wir bieten den Nothelferkurs (NHK) in den Regionen Aarau, Baden und Zürich zu einem günstigen Preis an. Für nur 69 CHF (inkl. Führerschein) können Sie die Erste Hilfe erlernen, die für den Führerschein obligatorisch ist.`,
  firstAidHome: "Erste Hilfe",
  firstAidHomeDesc: `Erste-Hilfe-Kurs für nur 69 CHF.
  Wir bieten den Nothelferkurs (NHK) in den Regionen Aarau, Baden und Zürich zu einem günstigen Preis an. Für nur 69 CHF (inkl. Führerschein) können Sie die Erste Hilfe erlernen, die für den Führerschein obligatorisch ist.`,
  title2Course: "VKU",
  parraph2Course: `Die obligatorische Verkehrsunterweisung (VKU) besteht aus vier Doppellektionen und kann parallel zu den praktischen Fahrstunden absolviert werden. Es ist jedoch ratsam, die VKU so früh wie möglich zu besuchen, damit wichtige Informationen in der praktischen Fahrlehre angewendet werden können.

  Der VKU kann nur mit einem gültigen Lernfahrausweis besucht werden. Dieser muss zum VKU mitgebracht werden.`,
  vkuHome: "VKU",
  vkuHomeDesc: `Die obligatorische Verkehrsunterweisung (VKU) besteht aus vier Doppellektionen und kann parallel zu den praktischen Fahrstunden absolviert werden. Es ist jedoch ratsam, die VKU so früh wie möglich zu besuchen, damit wichtige Informationen in der praktischen Fahrlehre angewendet werden können.

  Der VKU kann nur mit einem gültigen Lernfahrausweis besucht werden. Dieser muss zum VKU mitgebracht werden.`,
  parraph3Course: `Die Star Driving School hat sich auf dem Gebiet der Motorradgrundkurse etabliert. Die Kurse sind prüfungsnah und lehrreich aufgebaut. Mit viel Spass und Humor vergehen die Stunden wie im Flug. Viele unterschätzen das sehr hohe Niveau, das für die Prüfung in der Schweiz erforderlich ist. Letztes Jahr lag die Durchfallquote bei sage und schreibe 56%. Wir haben unseren Motorrad-Grundkurs so aufgebaut, dass Sie kaum Fahrstunden benötigen (vorausgesetzt, Sie erreichen die Kursziele und üben). Eine Fahrstunde für die Prüfung gibt Ihnen einen Eindruck davon, wie es in der Prüfung zugehen wird und dient der Standortbestimmung.`,
  motoHome: `MOTO`,
  motoHomeDesc: `Wir haben unseren Grundkurs Motorrad so aufgebaut, dass Sie kaum Fahrstunden benötigen (Kursziele und Übung vorausgesetzt). Eine Fahrstunde zur Prüfung gibt Ihnen einen Eindruck davon, wie die Prüfung ablaufen wird und hilft Ihnen herauszufinden, wo Sie stehen.`,
  navHome: "Startseite",
  navDrive: "Fahrschule",
  navFirstAid: "Nothelfer",
  navVku: "VKU",
  navMoto: "Motorrad",
  navPrice: "Preise",
  navPages: "Seiten",
  navVouchers: "Gutscheine",
  navContact: "Kontakt",
  navTeam: "Das Team",

  app: `app`,
  user: `user`,
  list: `list`,
  edit: `edit`,
  shop: `shop`,
  blog: `blog`,
  post: `post`,
  mail: `mail`,
  chat: `chat`,
  cards: `cards`,
  posts: `posts`,
  create: `create`,
  kanban: `kanban`,
  general: `general`,
  banking: `banking`,
  booking: `booking`,
  profile: `profile`,
  account: `account`,
  product: `product`,
  invoice: `invoice`,
  details: `details`,
  checkout: `checkout`,
  calendar: `calendar`,
  analytics: `analytics`,
  ecommerce: `e-commerce`,
  management: `management`,
  menu_level: `menu level`,
  menu_level_2a: `menu level 2a`,
  menu_level_2b: `menu level 2b`,
  menu_level_3a: `menu level 3a`,
  menu_level_3b: `menu level 3b`,
  menu_level_4a: `menu level 4a`,
  menu_level_4b: `menu level 4b`,
  item_disabled: `item disabled`,
  item_label: `item label`,
  item_caption: `item caption`,
  item_external_link: `item external link`,
  description: `description`,
  other_cases: `other cases`,
  item_by_roles: `item by roles`,
  only_admin_can_see_this_item: `Only admin can see this item`,
};

export default de;
